import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import orderDeliveryWindowsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-delivery-windows/order-delivery-windows.entity";
import { IAPIItemResult, IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { ICreateOrder } from "../interfaces/create-order-delivery.interface";
import { IUpdateMaterial } from "../interfaces/update-material.interface";
import TaxAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/tax/tax.entity";
import { ICreateTax } from "../interfaces/create-tax.interface";
import { environment as env } from "../../../../../../environments/environment.prod";


const apiUrl = env.API_MATERIAL_URL;
const moduleName = "material_tax";

@Injectable({
  providedIn: "root",
})
export class MaterialTaxService extends AbstractService<
TaxAttributes,
ICreateTax,
IUpdateMaterial
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByMaterialId(materialId: string,id:string): Observable<IAPIItemResult<TaxAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${materialId}/${id}`;
    return this.http.get<IAPIItemResult<TaxAttributes>>(API_URL);
  }
}